import CallMadeIcon from '@mui/icons-material/CallMade'
import CallReceivedIcon from '@mui/icons-material/CallReceived'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import PhoneIcon from '@mui/icons-material/Phone'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import React from 'react'

import { cannot } from '@/app/helpers'
import { TWhasappContentAction, TWhatsappActionsContent } from '@/app/types'

type Props = {
  content: TWhatsappActionsContent
}

type ActionConfig = {
  icon: React.ReactElement
  label: string
}

const WhatsappActionsMessage: React.FC<Props> = ({ content }) => (
  <Container>
    <Message>{content.message}</Message>
    <ButtonsStack spacing={1}>
      {content.actions.map((action, index) => {
        const config = getActionConfig(action)
        if (!config) {
          return null
        }

        return (
          <ActionButton key={`wa-action-${index}`} size="small" startIcon={config.icon} variant="text">
            {config.label}
          </ActionButton>
        )
      })}
    </ButtonsStack>
  </Container>
)

const getActionConfig = (action: TWhasappContentAction): ActionConfig | null => {
  if ('url' in action) {
    return {
      icon: <OpenInNewIcon fontSize="small" />,
      label: action.url.title,
    }
  }

  if ('phone' in action) {
    return {
      icon: <PhoneIcon fontSize="small" />,
      label: action.phone.title,
    }
  }

  if ('copyCode' in action) {
    return {
      icon: <ContentCopyIcon fontSize="small" />,
      label: action.copyCode.title,
    }
  }

  if ('ingressCall' in action) {
    return {
      icon: <CallReceivedIcon fontSize="small" />,
      label: action.ingressCall.title,
    }
  }

  if ('egressCallRequest' in action) {
    return {
      icon: <CallMadeIcon fontSize="small" />,
      label: action.egressCallRequest.title,
    }
  }

  cannot(action)
  return null
}

const Container = styled(Stack)(({ theme }) => ({
  alignItems: 'flex-start',
  gap: theme.spacing(1),
}))

const Message = styled(Typography)(() => ({
  whiteSpace: 'pre-line',
}))

const ButtonsStack = styled(Stack)(() => ({
  alignItems: 'flex-start',
}))

const ActionButton = styled(Button)(({ theme }) => ({
  paddingInline: theme.spacing(1),
  minHeight: 32,
}))

export default WhatsappActionsMessage
